module.exports = __webpack_public_path__ + "static/j-brueckner-1acf5661a32ff0a8d5ddb094d42af37b.png";